<template>
    <div class="inputgroup flex mb-2" :class="layoutClasses">
        <div class="label-wrapper">
            <Label :label="label" :id="label.replace(/[^a-zA-Z0-9]/g, '')" :required="required" v-if="label" />
        </div>
        <div class="form-elements flex flex-wrap" :class="layoutItemsClasses">
            <slot />
            <Error :error="error" v-if="error" />
        </div>
    </div>
</template>

<script>
import Label from "./Label";
import Error from "./Error";

export default {
    components: {
        Label,
        Error
    },
    props: {
        layout: {
            type: String,
            default: 'horizontal',//vertical
        },
        layoutItems: {
            type: String,
            default: 'vertical',//horizontal
        },
        label: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false
        },
        error: {
            type: String
        }
    },
    computed: {
        layoutClasses() {
            if (this.layout == 'vertical') {
                return 'vertical flex-col';
            } else {
                return 'horizontal';
            }
        },
        layoutItemsClasses() {
            if (this.layoutItems == 'vertical') {
                return 'flex-col';
            } else {
                return '';
            }
        },
    }
}
</script>

<style scoped>
.horizontal > .label-wrapper {
    min-width: 35%;
}

.horizontal > .form-elements {
    min-width: 65%;
}
</style>

<style>
.inputgroup .form-element span {
    display: none;/*hide required * */
}

.form-elements:not(.flex-col) .radio-checkbox:not(:last-child) {
    margin-right: 1rem;
}
</style>
